module.exports = __webpack_public_path__ + "media/07_ASANBUDAPEST-Vibes07.ab38f39c.mp3";